<template>
  <div class="image-viewer">
    <img 
      v-if="src" 
      :src="src" 
      :alt="alt"
      @error="handleError"
      @load="handleLoad"
      class="image"
    />
    <div v-else class="placeholder">
      <img :src="placeholderSrc" :alt="alt" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: '图片'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imageError: false
    }
  },
  computed: {
    placeholderSrc() {
      if (this.placeholder) {
        return this.placeholder
      }
      // 默认占位图
      return require('@/assets/images/placeholders/default.png')
    }
  },
  methods: {
    handleError() {
      this.imageError = true
      this.$emit('error')
    },
    handleLoad() {
      this.imageError = false
      this.$emit('load')
    }
  }
}
</script>

<style lang="scss" scoped>
.image-viewer {
  width: 100%;
  height: 100%;
  @include flex-center;
  
  .image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  .placeholder {
    width: 100%;
    height: 100%;
    @include flex-center;
    background: $bg-gray;
    
    img {
      max-width: 50%;
      max-height: 50%;
      opacity: 0.5;
    }
  }
}
</style>

